export default "__VITE_ASSET__DY8jwZD1__"